/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeoJsonPolygon
 */
export interface GeoJsonPolygon {
    /**
     * Polygon geometry type
     * @type {string}
     * @memberof GeoJsonPolygon
     */
    type: GeoJsonPolygonTypeEnum;
    /**
     * Polygon coordinates array of linear rings (first ring is exterior, others are holes)
     * @type {Array<Array<Array<number>>>}
     * @memberof GeoJsonPolygon
     */
    coordinates: Array<Array<Array<number>>>;
}


/**
 * @export
 */
export const GeoJsonPolygonTypeEnum = {
    Polygon: 'Polygon'
} as const;
export type GeoJsonPolygonTypeEnum = typeof GeoJsonPolygonTypeEnum[keyof typeof GeoJsonPolygonTypeEnum];


/**
 * Check if a given object implements the GeoJsonPolygon interface.
 */
export function instanceOfGeoJsonPolygon(value: object): value is GeoJsonPolygon {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function GeoJsonPolygonFromJSON(json: any): GeoJsonPolygon {
    return GeoJsonPolygonFromJSONTyped(json, false);
}

export function GeoJsonPolygonFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoJsonPolygon {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function GeoJsonPolygonToJSON(json: any): GeoJsonPolygon {
    return GeoJsonPolygonToJSONTyped(json, false);
}

export function GeoJsonPolygonToJSONTyped(value?: GeoJsonPolygon | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

